import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useWindowSize from '@hooks/useWindowSize';

import ArtworkList from '@features/assets/components/artwork/ArtworkList';
import AssetsTopFilter from '@features/assets/components/AssetsTopFilter';
import { assetsTabs } from '@features/assets/utils/AssetsUtil';
import BlockLibrary from '@features/assets/components/blockLibrary/BlockLibrary';
import SketchList from '@features/assets/components/sketch/SketchList';

import { getUserInfo } from '@utils/Util';

const AssetsWrapper = () => {
	const [isOpenFilter, setIsOpenFilter] = useState(true);
	const [totalElements, setTotalElements] = useState(0);
	const [activeTab, setActiveTab] = useState('BLOCK_LIBRARY');
	const [showAddModal, setShowAddModal] = useState(false);
	const [selectedViewType, setSelectedViewType] = useState(
		getUserInfo().systemPreference?.BLOCK_LIBRARY_LIST_TYPE
	);
	const navigate = useNavigate();
	useWindowSize(() => setIsOpenFilter(false));

	const handleTabChange = (tabName) => {
		setActiveTab(tabName);
		navigate(`/assets?activeTab=${tabName}`);
		window.scrollTo(0, 0);
	};

	const onSetViewSetting = (selected) => {
		setSelectedViewType(selected);
	};

	const renderTabContents = () => {
		switch (activeTab) {
			case 'SKETCH':
				return (
					<SketchList
						toggleFilter={() => setIsOpenFilter((prev) => !prev)}
						isShowFilter={isOpenFilter}
						setTotalElements={setTotalElements}
						showAddModal={showAddModal}
						setShowAddModal={setShowAddModal}
					/>
				);
			case 'ARTWORK':
				return (
					<ArtworkList
						toggleFilter={() => setIsOpenFilter((prev) => !prev)}
						isShowFilter={isOpenFilter}
						setTotalElements={setTotalElements}
						showAddModal={showAddModal}
						setShowAddModal={setShowAddModal}
					/>
				);

			default:
				return (
					<BlockLibrary
						toggleFilter={() => setIsOpenFilter((prev) => !prev)}
						isShowFilter={isOpenFilter}
						selectedViewType={selectedViewType}
						activeTab={activeTab}
						setTotalElements={setTotalElements}
					/>
				);
		}
	};

	return (
		<>
			<div className="top-header bg-white assets-top-filter">
				<div className="page-title-area">
					<h1 className="semibold-16">ASSETS</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp">
					<ul>
						<li
							onClick={() => handleTabChange(assetsTabs.BLOCK_LIBRARY)}
							className={activeTab === assetsTabs.BLOCK_LIBRARY ? 'active' : ''}
						>
							Block Library
						</li>
						<li
							onClick={() => handleTabChange(assetsTabs.SKETCH)}
							className={activeTab === assetsTabs.SKETCH ? 'active' : ''}
						>
							Sketch
						</li>
						<li
							onClick={() => handleTabChange(assetsTabs.ARTWORK)}
							className={activeTab === assetsTabs.ARTWORK ? 'active' : ''}
						>
							Artwork
						</li>
					</ul>
				</div>
				<AssetsTopFilter
					onSetViewSetting={onSetViewSetting}
					selectedViewType={selectedViewType}
					toggleFilter={() => setIsOpenFilter((prev) => !prev)}
					activeTab={activeTab}
					totalElements={totalElements}
					setShowAddModal={setShowAddModal}
				/>
			</div>

			{renderTabContents()}
		</>
	);
};

export default AssetsWrapper;
